import { castArray } from 'lodash';
import React, { FC, useEffect } from 'react';

import { Spinner } from 'src/components/spinner';
import { store } from 'src/state/configure-store';
import { Requests } from 'src/state/request/request-action';
import { areRequestsReady, getRequest, selectRequestsState } from 'src/state/request/selectors';
import { RequestStatus, RequestType } from 'src/state/request/types';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';

import { ProtectedRoute, ProtectedRouteProps } from './protected-route';

interface Props {
  requests?: RequestType[];
}

export type RequestRouteProps = Props & ProtectedRouteProps;

export const RequestRoute: FC<RequestRouteProps> = (props) => {
  const { requests, ...rest } = props;
  const requestsState = useAppSelector(selectRequestsState);
  const dispatch = useAppDispatch();

  useEffect(
    () => {
      if (requests) {
        requests.forEach((requiredRequest) => {
          const requestState = getRequest(requiredRequest)(store.getState());

          if (requestState.status === RequestStatus.IDLE) {
            dispatch(Requests[requiredRequest]);
          }
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(requests)],
  );

  if (requests && !areRequestsReady(requestsState, ...castArray(requests))) {
    return <Spinner />;
  }

  return <ProtectedRoute {...rest} />;
};
